import { TemplateFormat } from '@langchain/core/prompts';
import { Option, Select } from '@mui/joy';

const PromptTemplateFormatDropdown = ({
  templateFormat: templateFormat,
  onTemplateFormatSwitch: onTemplateFormatSwitch,
  disabled: disabled,
}: {
  templateFormat: TemplateFormat;
  onTemplateFormatSwitch?: (format: TemplateFormat) => void;
  disabled?: boolean;
}) => {
  return (
    <div className="ml-auto">
      <Select
        value={templateFormat}
        onChange={(_, value) => {
          onTemplateFormatSwitch &&
            onTemplateFormatSwitch(value as TemplateFormat);
        }}
        disabled={disabled}
        slotProps={{
          root: {
            sx: {
              width: 'unset',
              backgroundColor: 'transparent',
              border: 'none',
              padding: 0,
              paddingLeft: '8px',
              paddingRight: '8px',
              minHeight: 32,
              fontSize: 'normal',
              marginLeft: '-8px',
              marginTop: '-8px',
            },
          },
          button: {
            sx: (theme) => ({
              color: theme.vars.palette.neutral[500],
              fontWeight: 600,
            }),
          },
        }}
      >
        <Option value="f-string">f-string</Option>
        <Option value="mustache">mustache</Option>
      </Select>
    </div>
  );
};

export default PromptTemplateFormatDropdown;
